interface ReferrerStat {
  referrer: string;
  count: number;
}

interface TopReferrersProps {
  data: ReferrerStat[];
}

function cleanReferrer(ref: string): string {
  if (!ref) return 'Direct / None';
  try {
    const url = new URL(ref);
    return url.hostname.replace(/^www\./, '');
  } catch {
    return ref;
  }
}

export default function TopReferrers({ data }: TopReferrersProps) {
  return (
    <div className="bg-white dark:bg-stone-900 rounded-xl border border-stone-100 dark:border-stone-800 p-5">
      <h3 className="text-sm font-semibold text-stone-700 dark:text-stone-300 mb-4 flex items-center gap-2">
        <i className="ri-links-line text-amber-500" /> Traffic Sources
      </h3>
      {data.length === 0 ? (
        <p className="text-stone-400 text-sm text-center py-6">No data yet</p>
      ) : (
        <ul className="divide-y divide-stone-100 dark:divide-stone-800">
          {data.map((item, i) => (
            <li key={i} className="flex items-center justify-between py-2.5">
              <div className="flex items-center gap-2 min-w-0">
                <span className="text-xs text-stone-400 font-mono w-4">{i + 1}</span>
                <span className="text-xs text-stone-600 dark:text-stone-400 truncate">{cleanReferrer(item.referrer)}</span>
              </div>
              <span className="text-xs font-mono font-semibold text-stone-700 dark:text-stone-300 ml-2 whitespace-nowrap">
                {item.count.toLocaleString()}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
